import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { view04ImageOptions } from './views/view04'


class Galley extends Component {
    constructor(props) {
        super(props);
		this.handleGalleyChange = this.handleGalleyChange.bind(this);
    }

	handleGalleyChange(newValue) {
		let configuration = this.props.configuration;
		configuration.Galley = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}




    render() {
		let imageOptions = view04ImageOptions;

        let image = (
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>

					<h1><Trans defaults='Galley' /></h1>
					<p><Trans defaults='The pantry of the X-Power 33C powerboat ships as a fully functional galley. Optional is an extra cooling drawer.' /></p>
					<h2><Trans defaults='Do you need an extra cooling drawer?' /></h2>
                    
					<RadioGroup options={this.props.GalleyOptions} value={this.props.configuration.Galley} onChange={this.handleGalleyChange} />

                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Galley);


// WEBPACK FOOTER //
// ./src/Xpower/Galley.js